import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const JAM = "#b91c1c";
const SLOW = "#f97316";
const ROUTE = "#1d4ed8";
const NOIDA = [28.5355, 77.391];

// path = decoded polyline [{lat,lng}], jams = jammed_roads, wholeIsJam = incident (path itself is the jam)
const OoraTomtomRouteMap = ({ path = [], jams = [], wholeIsJam = false }) => {
  const box = useRef(null);
  const map = useRef(null);
  const layer = useRef(null);

  useEffect(() => {
    map.current = L.map(box.current).setView(NOIDA, 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors",
      maxZoom: 19,
    }).addTo(map.current);
    layer.current = L.layerGroup().addTo(map.current);
    return () => map.current.remove();
  }, []);

  useEffect(() => {
    layer.current.clearLayers();
    const all = [];

    const line = path.map((p) => [p.lat, p.lng]);
    if (line.length > 1) {
      const color = wholeIsJam ? (jams[0]?.speed === "SLOW" ? SLOW : JAM) : ROUTE;
      L.polyline(line, { color, weight: wholeIsJam ? 7 : 4, opacity: 0.9 }).addTo(layer.current);
      all.push(...line);
    }

    if (!wholeIsJam) {
      jams.forEach((j) => {
        if (!j.start || !j.end) return;
        const seg = [[j.start.lat, j.start.lng], [j.end.lat, j.end.lng]];
        L.polyline(seg, { color: j.speed === "SLOW" ? SLOW : JAM, weight: 9 })
          .bindTooltip(`${j.road_name || "Jam"} · ${j.speed === "SLOW" ? "Slow" : "Jam"}`, { sticky: true })
          .addTo(layer.current);
        all.push(...seg);
      });
    }

    if (all.length) map.current.fitBounds(all, { padding: [30, 30], maxZoom: 16 });
  }, [path, jams, wholeIsJam]);

  return <div ref={box} className="ott-map" />;
};

export default OoraTomtomRouteMap;